export default function getResource(label, vars = []) {
    const resources = {
        optinCreateHeading: 'Laissez tomber votre mot de passe lors de votre prochaine visite et connectez-vous de manière plus rapide et sécuritaire',
        subheading: 'Utilisez le même visage ou la même empreinte digitale que vous utilisez pour déverrouiller votre appareil. Nous ne recevons jamais vos données biométriques comme les empreintes digitales ou les balayages du visage.',
        warningNotification: 'Non recommandé pour les appareils partagés.',
        termsAndConditions: 'En cliquant sur « Continuer », vous (1) acceptez la version actuelle de nos ',
        termsOfUse: 'CONDITIONS D’UTILISATION',
        termsAndConditionsRest: ' et (2) confirmez avoir lu notre ',
        privacyPolicy: 'politique de confidentialité',
        whatIsPasskey: 'Qu’est-ce qu’une clé d’accès?',
        setupButton: 'Continuer',
        maybeLaterButton: 'Peut-être plus tard',
        laterButton: 'Plus tard',
        passkeyErrorTitle: 'Erreur',
        passkeyErrorMessage: 'Nous ne pouvons pas configurer votre clé d’accès pour l’instant. Veuillez essayer de nouveau.',
        passkeyErrorButton: 'OK',
        passkeyExpiredLinkMessage: 'Le lien vous permettant de créer une clé d’accès a expiré.<br><br>Cliquez sur « Renvoyer » pour recevoir un nouveau courriel à cet effet. Si vous n’êtes pas en mesure de créer une clé d’accès à partir du courriel, essayez d’utiliser un autre appareil ou de réinitialiser votre mot de passe. Si vous ne parvenez pas à réinitialiser votre mot de passe, vous pouvez communiquer avec le service à la clientèle au 1-877-SEPHORA (1-877-377-4672) pour obtenir de l’aide',
        passkeyUnsupportedDeviceMessage: 'Votre appareil n’est pas admissible à la création d’une clé d’accès.',
        createNewPasskey: 'Créer un nouveau mot de passe',
        cancel: 'Annuler',
        passkeyCreated: 'Clé d’accès créée!',
        optinCreateAccountHeading: 'Créer un nouveau mot de passe'
    };

    return resources[label];
}
